import { render, staticRenderFns } from "./DirectMessageRecorder.vue?vue&type=template&id=57a375c2&scoped=true"
import script from "./DirectMessageRecorder.vue?vue&type=script&lang=js"
export * from "./DirectMessageRecorder.vue?vue&type=script&lang=js"
import style0 from "./DirectMessageRecorder.vue?vue&type=style&index=0&id=57a375c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a375c2",
  null
  
)

export default component.exports